import { FontIcon, TooltipHost } from "@fluentui/react";
import { observer } from "mobx-react";
import { store } from "../../store";

export interface ChecklistLogoutBadgeProps {
    /** Minutes configured on the checklist, or `null`/`undefined` when off. */
    readonly minutesUntilLogout: number | null | undefined;
}

/**
 * Marks a checklist that logs the driver out when it isn't completed in time,
 * and says how long they have.
 *
 * Checklists without a timer render nothing at all: the timer is the exception,
 * and a row of "off" badges down the list would only add noise.
 */
export const ChecklistLogoutBadge = observer(
    ({ minutesUntilLogout }: ChecklistLogoutBadgeProps): JSX.Element => {
        // Reading a checklist maps a `null` timer to `undefined`, so both have
        // to count as "off" here.
        if (minutesUntilLogout == null) {
            return <></>;
        }

        const minutes = minutesUntilLogout;
        return (
            <TooltipHost
                content={store.i18n.t("listPreOpsChecklist.logoutTimer.tooltip", { minutes })}
            >
                <span className="border-border inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-sm font-medium whitespace-nowrap">
                    <FontIcon className="text-base" iconName="Timer" />
                    {store.i18n.t("listPreOpsChecklist.logoutTimer.label", { minutes })}
                </span>
            </TooltipHost>
        );
    },
);
